import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditInstitutionSchool = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit School or College'
      fields={fields}
      apiPath={`admin/institution_schools/${props.params.institutionSchoolId}`}
      successRedirectPath={`/membership/institutions/${props.params.institutionId}/schools`}
      buildMenuItems={menuItems}
    />
  )
}

export default EditInstitutionSchool
